import request from "@/utils/request";

export function getHistory(category) {
  return request({
    url: "resume/gethistory",
    method: "post",
    data: {
      Category: category,
    },
  });
}

export function downloadAttach(fserial, token) {
  return request({
    url: "resume/downloadattach",
    method: "post",
    data: {
      RequestID: fserial,
      HashToken: token,
    },
  });
}

export function removeAttach(category, fserial) {
  return request({
    url: "resume/removeattach",
    method: "post",
    data: {
      RequestID: fserial,
      Category: category,
    },
  });
}

export function removeRecord(category, fserial) {
  return request({
    url: "resume/remove",
    method: "post",
    data: {
      RequestID: fserial,
      Category: category,
    },
  });
}

export function saveRecord(file, record, categoryName) {
  var fmData = new FormData();
  for (var key in record) {
    fmData.append(key, record[key]);
  }

  fmData.append("categoryName", categoryName);
  fmData.append("image", file);

  return request({
    url: "resume/save",
    method: "post",
    data: fmData,
  });
}

export function getCategories() {
  return request({
    url: "resume/categories",
    method: "post",
  });
}

export function getShakheses() {
  return request({
    url: "resume/shakheses",
    method: "post",
  });
}

export function getReportCard(shakhesObj) {
  return request({
    url: "resume/reportcard",
    method: "post",
    data: shakhesObj,
  });
}
